import React, { Component } from 'react'
import Select from 'react-select-plus'
import Icon from 'svg-inline-react'
import { COMPANY_CATEGORIES } from 'components/settings/Rules/constants/company_categories'
import { 
  GEO_FILTER_OPERATORS,
  CATEGORY_FILTER_OPERATORS
} from 'app/modules/rules/constants'

const closeSRC = require('!svg-inline?removeTags=true!images/icons/times-icon.svg')


class CompanyTagsFilter extends Component {

  constructor(props) {
    super(props)

    const { value, field } = props.activeFilter

    this.state = {
      selectedCategories: value || [],
      fieldType: field,
    }
  }
  
  componentDidMount() {
    this.updateCondition()
  }

  getFormattedTags() {
    const unusedCategories = _.without(COMPANY_CATEGORIES, ...this.state.selectedCategories)
    return unusedCategories.map((category) => {
      return { label: category, value: category }
    })
  }

  removeCategory = (value) => {
    this.setState((prevState)=>{
      return {
        selectedCategories: _.without(prevState.selectedCategories, value)
      }
    }, this.updateCondition)
  }

  saveCategory = (values) => {
    this.setState((prevState)=>{
      const newOptions = prevState.selectedCategories.slice(0)
      const onlyValues = values.map((option) => option.value)
      newOptions.push(...onlyValues)
      newOptions.sort()

      return {
        selectedCategories: newOptions
      }
    }, this.updateCondition)
  }

  updateCondition = () => {
    const updatedCondition = {
      operator: CATEGORY_FILTER_OPERATORS.IS_ANY, 
      value: this.state.selectedCategories
    }

    this.props.onUpdateCondition(updatedCondition)
  }

  getListHeight() {
    const itemHeight = 75
    const totalColumns = 2
    const maxHeight = (this.state.selectedCategories.length * itemHeight) / totalColumns + itemHeight
    return { 
      height: `${ maxHeight }px`
    }
  }

  renderSelectOption = ({ label }) => {
    return (
      <div className="geo-option choice-dropdown-option">
        <span className="choice-option-value">{label}</span>
        <span className="choice-option-add">+Add</span>
      </div>
    )
  }

  renderSearchBar() {
    const selectOptions = {
      multi: true,
      autoFocus: true,
      options: this.getFormattedTags(),
      pageSize: 10,
      optionRenderer: this.renderSelectOption,
      onChange: this.saveCategory,
      placeholder: 'Choose a category...'
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderTagSelectionList = () => {
    return (
      <ul style={ this.getListHeight() } >
        { 
          this.state.selectedCategories.map((option, index)=> {
            return (<li key={`${option}-${index}`}><span>{option}</span> <Icon src={closeSRC} className="remove" onClick={ () => this.removeCategory(option) }></Icon></li>) 
          })
        }
      </ul>
    )
  }

  render() {
    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-options">
          {this.renderSearchBar()}
        </div>

        <div className="rules-choice-selection rules-choice-selection-multi-column">
         {this.renderTagSelectionList()}
        </div>
      </div>
    )
  }
}

export default CompanyTagsFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/CompanyTagsFilter.js